import { render, staticRenderFns } from "./uni-easyinput.vue?vue&type=template&id=3490cdcb&scoped=true"
import script from "./uni-easyinput.vue?vue&type=script&lang=js"
export * from "./uni-easyinput.vue?vue&type=script&lang=js"
import style0 from "./uni-easyinput.vue?vue&type=style&index=0&id=3490cdcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3490cdcb",
  null
  
)

export default component.exports